import { render, staticRenderFns } from "./arrivals_departures_board.vue?vue&type=template&id=282fd762&scoped=true&"
import script from "./arrivals_departures_board.vue?vue&type=script&lang=js&"
export * from "./arrivals_departures_board.vue?vue&type=script&lang=js&"
import style0 from "./arrivals_departures_board.vue?vue&type=style&index=0&id=282fd762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fd762",
  null
  
)

export default component.exports